module.exports = __webpack_public_path__ + "static/media/ErrorIllustration.166e8ea5.png";